import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'company-layout-root',
  templateUrl: './company-layout.component.html',
  styleUrls: ['./company-layout.component.scss']
})
export class CompanyLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
